import NewBaseTableContent from './NewBaseTableContent.vue';
export default NewBaseTableContent;
